module.exports = __webpack_public_path__ + "img/click.fc153da2.png";